<div class="cb-margin-left-3x cb-margin-right-3x cb-margin-bottom-3x flex-col flex">
    <div class="start-center flex-row layoutGap-16">
        <h3 class="mat-headline-6 flex">Payment Template Events</h3>
        <button
            mat-raised-button
            (click)="newItemClicked()"
            [disabled]="!canEdit()"
            color="primary"
        >
            New Event
        </button>
        <button
            mat-raised-button
            (click)="saveOrder()"
            [disabled]="!sortOrderChanged || !canEdit()"
            color="primary"
        >
            Save Events Order
        </button>
    </div>
    <div class="cb-table cb-margin-top">
        <mat-table
            [dataSource]="searchResults"
            cdkDropList
            (cdkDropListDropped)="drop($event)"
            [cdkDropListData]="searchResults"
            class="cdk-drop-list"
        >
            <ng-container matColumnDef="code">
                <mat-header-cell *matHeaderCellDef> Code </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{ element.code }}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="label">
                <mat-header-cell *matHeaderCellDef> Event </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{ element.label }}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="active">
                <mat-header-cell *matHeaderCellDef> Active </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <mat-icon>
                        {{ element.isActive ? 'check_box' : 'check_box_outline_blank' }}
                    </mat-icon>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions" stickyEnd>
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <button
                        mat-icon-button
                        (click)="editItemClicked(element)"
                        [disabled]="!canEdit()"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row
                *matRowDef="let row; columns: displayedColumns"
                cdkDrag
                [cdkDragData]="row"
                class="cdk-drag"
            >
            </mat-row>
        </mat-table>
        @if (searchResultsLoaded && searchResults.length === 0) {
            <cb-info-message
                [message]="'There are no Payment Template Events to display'"
                [icon]="'info_circle'"
            ></cb-info-message>
        }
        @if (!searchResultsLoaded) {
            <cb-loading-spinner></cb-loading-spinner>
        }
    </div>
</div>
